import Typography from 'components/global/Typography';

import * as S from './styled/NotFoundSms.styled';

const NotFoundSms = () => (
	<S.Container>
		<S.InnerContainer shadowed rounded>
			<S.LottieStyled name="not-found-sms" width="auto" height="auto" />
			<Typography style={{ fontSize: '2.5rem' }} fontWeight="500">
				sms.notFoundTitle
			</Typography>
			<Typography className="mt-4 mb-5" color="var(--content-3)" fontWeight="500">
				sms.notFoundDescription
			</Typography>
		</S.InnerContainer>
	</S.Container>
);

export default NotFoundSms;
